import useRegistrationYear from '@/hooks/useRegistrationYear';
import { Grid, Typography } from '@mui/material';
import { InputOnlyField, ToggleButtonGroup } from '@ngt/forms';
import { FC } from 'react';

const parse: any = (inputValue: any) => 
    inputValue === 0 ?
        false :
        inputValue === 1 ?
            true :
            undefined

const convert: any = (fieldValue: any) => 
    fieldValue === false ?
        0 :
        fieldValue === true ?
            1 :
            undefined;


const RegistrationPreferencesFields: FC = () => {
    const registrationYear = useRegistrationYear();
    const delegateListingLabel = `Do you agree to your name and contact details being included in the ${registrationYear} BCT ASM Delegate Listing?`;

    return (
        <>
            <Grid item xs={12}>
                <Typography variant='h2' sx={{mt: 2, mb: 1}}>Preferences</Typography>
            </Grid>

            <Grid
                container
                columnSpacing={4}
                mt={4}
                ml={1}
            >
                <Grid item xs={10} md={8}><Typography>Do you require any disability access to the event?</Typography></Grid>
                <Grid item xs={12} md={4} sx={{ mt: { xs: 2, md: 0 }}}>
                    <InputOnlyField
                        label="Do you require any disability access to the event?"
                        propertyPath="requiresDisabilityAccess"
                        component={ToggleButtonGroup}
                        sx={{margin:"normal"}}
                    />
                </Grid>
            </Grid>
            <Grid
                container
                columnSpacing={4}
                mt={4}
                ml={1}
            >
                <Grid item xs={12} md={8} sx={{ pl: { xs: 0, md: 10 } }}>
                    <Typography>Do you require any visual or audio assistance at the event?</Typography>
                </Grid>
                <Grid item xs={12} md={4} sx={{ mt: { xs: 2, md: 0 }}}>
                    <InputOnlyField
                        label="Do you require any visual or audio assistance at the event?"
                        propertyPath="requiresAVAssistance"
                        component={ToggleButtonGroup}
                        sx={{margin:"normal"}}
                    />
                </Grid>
            </Grid>

            <Grid
                container
                columnSpacing={4}
                mt={4}
                ml={1}
            >
                <Grid item xs={12} md={8}><Typography>{delegateListingLabel}</Typography></Grid>
                <Grid item xs={12} md={4} sx={{ mt: { xs: 2, md: 0 }}}>
                    <InputOnlyField
                        label={delegateListingLabel}
                        propertyPath="includeDetails"
                        component={ToggleButtonGroup}
                        sx={{margin:"normal"}}
                        parse={parse}
                        convert={convert}
                    />
                </Grid>
            </Grid>
            <Grid
                container
                columnSpacing={4}
                mt={4}
                ml={1}
            >
                <Grid item xs={12} md={8}><Typography>Would you like to receive a certificate of attendance?</Typography></Grid>
                <Grid item xs={12} md={4} sx={{ mt: { xs: 2, md: 0 }}}>
                    <InputOnlyField
                        label="Would you like to receive a certificate of attendance?"
                        propertyPath="receiveCertificate"
                        component={ToggleButtonGroup}
                        sx={{margin:"normal"}}
                        parse={parse}
                        convert={convert}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default RegistrationPreferencesFields;
